.travelHistory-submitted .travelHistory.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=travel-history-add-edit.component-VLBKOH2Q.css.map */
